import React, { useRef, useState } from "react";
import UploadFilesPreview from "./UploadFilesPreview.js";
import UploaderHeader from "./UploaderHeader.js";
import Icon from "../../../Elements/Icon/Icon.tsx";
import GoBackComponent from "../Reusable/GoBackComponent.js";
import UploaderEmptyDragArea from "./UploaderDropArea.js";
import { useDragUploader } from "../Helpers/useDragUploader.js";
import { useUploader } from "../../../../contexts/uploaderContext/uploaderContext.js";
import { UploaderSideBar } from "./UploaderSideBar.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import { UploaderFooter } from "./UploaderFooter.js";
import { useUploaderInput } from "../Helpers/useUploaderInput.js";
import { ButtonAccessability } from "components/Elements/Button/Button.js";

export const UploaderDragArea = () => {
  const { getTextByKey } = useContent();
  const { getUploading } = useUploader();

  const filesRef = useRef();
  const folderRef = useRef();

  const { handleAddFiles, handleAddFolders } = useUploaderInput({
    filesRef,
    folderRef,
  });

  return getUploading() ? null : (
    <div className="preview-upload-area">
      <div className="upload-area-ui">
        <ButtonAccessability
          onClick={handleAddFiles}
          buttonClassName={"add-more-button"}
        >
          <Icon name={"home/add_files"} />
          {getTextByKey("add-files-uploader")}
        </ButtonAccessability>
        <ButtonAccessability
          onClick={handleAddFolders}
          buttonClassName={"add-more-button"}
        >
          <Icon name={"home/add_folder"} />
          {getTextByKey("add-folder-uploader")}
        </ButtonAccessability>
        <div className="hidden-inputs">
          <input type="file" className="files-input" ref={filesRef} multiple />
          <input
            type="file"
            className="folders-input"
            aria-hidden="true"
            webkitdirectory=""
            directory=""
            multiple
            ref={folderRef}
          ></input>
        </div>
      </div>
    </div>
  );
};

export const UploaderComponent = () => {
  const [listView, setListView] = useState(false);
  const [sideBarOption, setSideBarOption] = useState(null);
  const { uploaderGetFiles, getUploading } = useUploader();
  const { getTextByKey } = useContent();

  const { handleDrop, handleDrag, dragged } = useDragUploader();

  return (
    <>
      <GoBackComponent />
      <div className="home-upload-container">
        <div className="home-upload-content">
          <UploaderHeader {...{ setListView, listView }} />
          {uploaderGetFiles().length !== 0 ? (
            <div
              className="home-upload-content-workspace"
              onDrop={handleDrop}
              onDragEnter={handleDrag}
              onDragLeave={handleDrag}
              onDragOver={handleDrag}
            >
              {dragged && !getUploading() ? (
                <div className="drag-zone-highlight">
                  <Icon name="upload-home" blue />
                  <div className="drop-here-text">
                    {getTextByKey("drop-here-text")}
                  </div>
                </div>
              ) : null}
              <UploadFilesPreview {...{ listView }} />
              <div className="flex-spacer"></div>
            </div>
          ) : (
            <UploaderEmptyDragArea {...{ handleDrop, handleDrag, dragged }} />
          )}
          <div className="flex-spacer"></div>
          <UploaderFooter />
        </div>
        <UploaderSideBar {...{ sideBarOption, setSideBarOption }} />
      </div>
    </>
  );
};
